import { render } from "./EditInvoice.vue?vue&type=template&id=2e15302c"
import script from "./EditInvoice.vue?vue&type=script&lang=js"
export * from "./EditInvoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__